<template>
  <div 
    class="  px-5 mt-5">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-dialog v-model="dialog.status"
            @keydown.esc="dialog.status = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Mengubah Status
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin mengubah status perubahan data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?

                <div>
                  <ValidationObserver 
                    ref="form">
                    <v-form>

                      <div
                        class="mb-6 mt-5"  v-if="message.status === 'tolak'">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="rejected_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      

                      <div
                        class="mb-6 mt-5" v-if="message.status === 'terima' && approved_by.length > 0">
                        <ValidationProvider 
                          name="Alasan" 
                          rules="required" 
                          v-slot="{ errors }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Alasan
                          </div>

                          <v-textarea
                            v-on:keyup.enter="save()"
                            
                            filled
                            rounded
                            dense
                            rows="3"
                            solo

                            :color="set_color"
                            placeholder="Contoh. Tuliskan alasan disini . . ."


                            v-model="approved_reason"
                            :error-messages="errors"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </ValidationProvider>
                      </div>
                      
                    </v-form>
                  </ValidationObserver>
                </div>
  
                <div v-if="message.error.length > 0"
                  class="text-left mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-13 white--text text-capitalize border-radius">
                  Ya, {{ message.status }}
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-row
            class="mt-3">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                  <div class="black--text fs-20 font-weight-bold mb-1">
                    Detail Perubahan Customer <span v-if="Object.keys(detail).length > 0">{{ detail.name }}</span>
                  </div>
                  <div class="black--text fs-15" style="font-weight: 600">
                    Nama Sales: {{ detail.sales_name }}
                  </div>
                  <v-row>
                    <v-col>
                      <div class="fs-15 mb-3 black--text" style="font-weight: 600">
                        Data Lama
                      </div>
                      <div>
                        <table style="width: auto;">
                          <tr>
                            <td class="fs-14">
                              Nama
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.name !== '' && detail.name !== detail.customer_json.customer_name ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Alias
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.name_alias !== '' && detail.name_alias !== detail.customer_json.customer_name_alias ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_name_alias }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              NIK
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.nik !== '' && detail.nik !== detail.customer_json.customer_nik ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_nik }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Email
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.email !== '' && detail.email !== detail.customer_json.customer_email ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_email }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Mobilephone
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14">
                                <span v-if="detail.customer_json.customer_mobilephone_arr.length > 0">
                                  <!-- <span v-for="(item, i) in detail.customer_json.customer_mobilephone_arr" :key="i">
                                    {{ item }},
                                  </span> -->
                                  <table>
                                    <tr v-for="(item, i) in detail.customer_json.customer_mobilephone_arr" :key="i">
                                      <td>
                                        <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>
                                      </td>
                                      <td :style="detail.mobilephone_arr.length > 0 && detail.mobilephone_arr[i] !== detail.customer_json.customer_mobilephone_arr[i] ? 'color: red !important; font-weight: bold;' : ''" class="text-left py-1 pr-1 pl-5">
                                        : {{ item }}
                                      </td>
                                    </tr>
                                  </table>
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              NPWP
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.npwp !== '' && detail.npwp !== detail.customer_json.customer_npwp ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_npwp }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Faktur
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.faktur !== '' ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_faktur }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Ketentuan
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.term !== '' ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_term }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Tempat Lahir
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.birthplace !== '' && detail.birthplace !== detail.customer_json.customer_birthplace ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_birthplace === '' ? '-' : detail.customer_json.customer_birthplace }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Tanggal Lahir
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.birthdate !== '' && detail.birthdate !== detail.customer_json.customer_birthdate ? 'color: red !important; font-weight: bold;' : ''">
                                <span v-if="detail.customer_json.customer_birthdate === ''">
                                  -
                                </span>
                                <span v-else>
                                  {{ detail.customer_json.customer_birthdate | date }}
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Agama
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.religion !== '' && detail.religion !== detail.customer_json.customer_religion ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_religion === '' ? '-' : detail.customer_json.customer_religion }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Alamat
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.address !== '' && detail.address !== detail.customer_json.customer_address ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_address === '' ? '-' : detail.customer_json.customer_address }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Provinsi
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.province_name !== '' && detail.province_name !== detail.customer_json.customer_province_name ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_province_name === '' ? '-' : detail.customer_json.customer_province_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Kabupaten
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.city_name !== '' && detail.city_name !== detail.customer_json.customer_city_name ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_city_name === '' ? '-' : detail.customer_json.customer_city_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Kecamatan
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.subdistrict_name !== '' && detail.subdistrict_name !== detail.customer_json.customer_subdistrict_name ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_subdistrict_name === '' ? '-' : detail.customer_json.customer_subdistrict_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Kelurahan
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.village_name !== '' && detail.village_name !== detail.customer_json.customer_village_name ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_village_name === '' ? '-' : detail.customer_json.customer_village_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Latitude
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.latitude !== '' && detail.latitude !== detail.customer_json.customer_latitude ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_latitude === '' ? '-' : detail.customer_json.customer_latitude }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Longitude
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.longitude !== '' && detail.longitude !== detail.customer_json.customer_longitude ? 'color: red !important; font-weight: bold;' : ''">
                                {{ detail.customer_json.customer_longitude === '' ? '-' : detail.customer_json.customer_longitude }}
                              </div>
                            </td>
                          </tr>
                        </table>
                        

                        <!-- <div>
                          <div 
                            class="fs-12">
                           
                            Nama
                          </div>
                          <div class="fs-13 label-input" :style="detail.name !== '' && detail.name !== detail.customer_json.customer_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Alias
                          </div>
                          <div class="fs-13 label-input" :style="detail.name_alias !== '' && detail.name_alias !== detail.customer_json.customer_name_alias ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_name_alias }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            NIK
                          </div>
                          <div class="fs-13 label-input" :style="detail.nik !== '' && detail.nik !== detail.customer_json.customer_nik ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_nik }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Email
                          </div>
                          <div class="fs-13 label-input" :style="detail.email !== '' && detail.email !== detail.customer_json.customer_email ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_email }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                           
                            Mobilephone
                          </div>
                          <div class="fs-13 label-input">
                            <span v-if="detail.customer_json.customer_mobilephone_arr.length > 0">
                              <table>
                                <tr v-for="(item, i) in detail.customer_json.customer_mobilephone_arr" :key="i">
                                  <td>
                                    <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>
                                  </td>
                                  <td :style="detail.mobilephone_arr.length > 0 && detail.mobilephone_arr[i] !== detail.customer_json.customer_mobilephone_arr[i] ? 'color: red !important; font-weight: bold;' : ''" class="text-left py-1 pr-1 pl-5">
                                    : {{ item }}
                                  </td>
                                </tr>
                              </table>
                            </span>
                            <span v-else>
                              -
                            </span>
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            NPWP
                          </div>
                          <div class="fs-13 label-input" :style="detail.npwp !== '' && detail.npwp !== detail.customer_json.customer_npwp ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_npwp }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Faktur
                          </div>
                          <div class="fs-13 label-input" :style="detail.faktur !== '' ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_faktur }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Ketentuan
                          </div>
                          <div class="fs-13 label-input" :style="detail.term !== '' ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_term }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Tempat Lahir
                          </div>
                          <div class="fs-13 label-input" :style="detail.birthplace !== '' && detail.birthplace !== detail.customer_json.customer_birthplace ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_birthplace === '' ? '-' : detail.customer_json.customer_birthplace }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Tanggal Lahir
                          </div>
                          <div class="fs-13 label-input" :style="detail.birthdate !== '' && detail.birthdate !== detail.customer_json.customer_birthdate ? 'color: red !important; font-weight: bold;' : ''">
                            <span v-if="detail.customer_json.customer_birthdate === ''">
                              -
                            </span>
                            <span v-else>
                              {{ detail.customer_json.customer_birthdate | date }}
                            </span>
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Agama
                          </div>
                          <div class="fs-13 label-input" :style="detail.religion !== '' && detail.religion !== detail.customer_json.customer_religion ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_religion === '' ? '-' : detail.customer_json.customer_religion }}
                          </div>
                        </div>  

                        <div>
                          <div 
                            class="fs-12">
                            Alamat
                          </div>
                          <div class="fs-13 label-input" :style="detail.address !== '' && detail.address !== detail.customer_json.customer_address ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_address === '' ? '-' : detail.customer_json.customer_address }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Nama Provinsi
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.province_name !== '' && detail.province_name !== detail.customer_json.customer_province_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_province_name === '' ? '-' : detail.customer_json.customer_province_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                            Nama Kabupaten
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.city_name !== '' && detail.city_name !== detail.customer_json.customer_city_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_city_name === '' ? '-' : detail.customer_json.customer_city_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                            Nama Kecamatan
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.subdistrict_name !== '' && detail.subdistrict_name !== detail.customer_json.customer_subdistrict_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_subdistrict_name === '' ? '-' : detail.customer_json.customer_subdistrict_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                            Nama Kelurahan
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.village_name !== '' && detail.village_name !== detail.customer_json.customer_village_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_village_name === '' ? '-' : detail.customer_json.customer_village_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Latitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.latitude !== '' && detail.latitude !== detail.customer_json.customer_latitude ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_latitude === '' ? '-' : detail.customer_json.customer_latitude }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Longitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.longitude !== '' && detail.longitude !== detail.customer_json.customer_longitude ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.customer_json.customer_longitude === '' ? '-' : detail.customer_json.customer_longitude }}
                          </div>
                        </div> -->


                        <!-- <div>
                          <div 
                            class="fs-12">
                            Toko
                          </div>
                          <div class="fs-13 label-input" v-if="detail.store === null || detail.store.length < 1">
                            -
                          </div>
                          <div class="fs-13 label-input" v-else>
                            <v-list
                              subheader
                              three-line
                            >
                              <v-list-item
                                v-for="(item, index) in detail.store"
                                :key="index"
                                class="pl-0"
                              >
                                <v-list-item-avatar class="mr-3" tile>
                                  <v-icon
                                    color="#718EBF"
                                    size="45"
                                  >
                                    mdi-store
                                  </v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title>{{ item.store_name }}</v-list-item-title>

                                  <v-list-item-subtitle>{{ item.store_address }}</v-list-item-subtitle>
                                </v-list-item-content>

                              </v-list-item>
                            </v-list>
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12 mb-2">
                            Histori Approval
                          </div>
                          <div>
                            <div class="fs-15">
                              General Manager
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.gm_name === '' ? '-' : detail.edit_approval.General_Manager[0].user_name }} <span v-if="detail.edit_approval.General_Manager.length > 0">({{ detail.edit_approval.General_Manager[0].edit_approval_datetime | datetime }})</span>
                            </div>
                          </div>

                          <div>
                            <div class="fs-15">
                              Sales Manager
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.sm_name === '' ? '-' : detail.edit_approval.Sales_Manager[0].user_name }} <span v-if="detail.edit_approval.Sales_Manager.length > 0">({{ detail.edit_approval.Sales_Manager[0].edit_approval_datetime | datetime }})</span>
                            </div>
                          </div>

                          <div>
                            <div class="fs-15">
                              Supervisor
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.spv_name === '' ? '-' : detail.edit_approval.Supervisor[0].user_name }} <span v-if="detail.edit_approval.Supervisor.length > 0">({{ detail.edit_approval.Supervisor[0].edit_approval_datetime | datetime }})</span>
                            </div>
                          </div>
                        </div> -->

                        <!-- <div class="mb-3" :style="detail.ttd !== '' ? 'color: red !important; font-weight: bold;' : ''">
                          Peta Lokasi
                        </div> -->

                        <div class="mb-3" :style="(detail.latitude !== '' && detail.latitude !== detail.customer_json.customer_latitude) || (detail.longitude !== '' && detail.longitude !== detail.customer_json.customer_longitude) ? 'color: red !important; font-weight: bold;' : ''">
                          Peta Lokasi
                        </div>
                        <div>
                          <div v-if="detail.customer_json.customer_longitude === '' && detail.customer_json.customer_longitude === ''">
                            -
                          </div>
                          <div class="mt-6" v-else>
                              <a 
                                :href="`https://www.google.com/maps/search/?api=1&query=${detail.customer_json.customer_latitude},${detail.customer_json.customer_longitude}`"
                                style="color:#0000FF;text-align:left" 
                                  target="_blank">
                                    <iframe 
                                      width="100%" 
                                      height="170" 
                                      frameborder="0" 
                                      scrolling="no" 
                                      marginheight="0" 
                                      marginwidth="0" 
                                      :src="`https://maps.google.com/maps?q=${detail.customer_json.customer_latitude},${detail.customer_json.customer_longitude}&hl=es&z=14&amp;output=embed`"
                                      >
                                    </iframe>
                                  </a>
                            </div>
                        </div>

                        <div class="mb-3" :style="detail.ttd !== '' && detail.ttd !== detail.customer_json.customer_ttd ? 'color: red !important; font-weight: bold;' : ''">
                          Gambar Tanda Tangan
                        </div>

                        <v-img
                          :src="detail.customer_json.customer_ttd"
                          contain
                          width="250"
                          height="150"
                          >
                        </v-img>


                      </div>
                    </v-col>
                    <v-col style="border-left: 1px solid #E7E7E7;">
                      <div class="fs-15 mb-3 black--text" style="font-weight: 600">
                        Data Baru
                      </div>
                      <div>
                        <table style="width: auto;">
                          <tr>
                            <td class="fs-14">
                              Nama
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.name !== '' && detail.name !== detail.customer_json.customer_name ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.name === '' ? detail.customer_json.customer_name : detail.name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Alias
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.name_alias !== '' && detail.name_alias !== detail.customer_json.customer_name_alias ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.name_alias === '' ? detail.customer_json.customer_name_alias : detail.name_alias }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              NIK
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.nik !== '' && detail.nik !== detail.customer_json.customer_nik ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.nik === '' ? detail.customer_json.customer_nik : detail.nik }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Email
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.email !== '' && detail.email !== detail.customer_json.customer_email ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.email === '' ? detail.customer_json.customer_email : detail.email }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Mobilephone
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14">
                                <div v-if="detail.mobilephone_arr.length < 1">
                                  <span v-if="detail.customer_json.customer_mobilephone_arr.length > 0">
                                    <!-- <span v-for="(item, i) in detail.customer_json.customer_mobilephone_arr" :key="i">
                                      {{ item }},
                                    </span> -->
                                    <table>
                                      <tr v-for="(item, i) in detail.customer_json.customer_mobilephone_arr" :key="i">
                                        <td>
                                          <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>
                                        </td>
                                        <td class="text-left py-1 pr-1 pl-5"  :style="detail.mobilephone_arr.length > 0 && detail.mobilephone_arr[i] !== detail.customer_json.customer_mobilephone_arr[i] ? 'color: green !important; font-weight: bold;' : ''">
                                          : {{ item }}
                                        </td>
                                      </tr>
                                    </table>
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </div>
                                <div v-if="detail.mobilephone_arr.length > 0">
                                  <span v-if="detail.mobilephone_arr.length > 0">
                                    <!-- <span v-for="(item, i) in detail.mobilephone_arr" :key="i">
                                      {{ item }},
                                    </span> -->
                                    <table>
                                      <tr v-for="(item, i) in detail.mobilephone_arr" :key="i">
                                        <td>
                                          <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>
                                        </td>
                                        <td class="text-left py-1 pr-1 pl-5" :style="detail.mobilephone_arr.length > 0 && detail.mobilephone_arr[i] !== detail.customer_json.customer_mobilephone_arr[i] ? 'color: green !important; font-weight: bold;' : ''">
                                          : {{ item }}
                                        </td>
                                      </tr>
                                    </table>
                                  </span>
                                  <span v-else>
                                    -
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              NPWP
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.npwp !== '' && detail.npwp !== detail.customer_json.customer_npwp ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.npwp === '' ? detail.customer_json.customer_npwp : detail.npwp }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Faktur
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.faktur !== '' ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.faktur === '' ? detail.customer_json.customer_faktur : detail.faktur }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Ketentuan
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.term !== '' ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.term === '' ? detail.customer_json.customer_term : detail.term }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Tempat Lahir
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.birthplace !== '' && detail.birthplace !== detail.customer_json.customer_birthplace ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.birthplace === '' ? detail.customer_json.customer_birthplace === '' ? '-' : detail.customer_json.customer_birthplace : detail.birthplace }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Tanggal Lahir
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.birthdate !== '' && detail.birthdate !== detail.customer_json.customer_birthdate ? 'color: green !important; font-weight: bold;' : ''">
                                <span v-if="detail.birthdate === ''">
                                  <span v-if="detail.customer_json.customer_birthdate === ''">
                                    -
                                  </span>
                                  <span v-else>
                                    {{ detail.customer_json.customer_birthdate | date }}
                                  </span> 
                                </span>

                                <span>
                                  {{ detail.birthdate | date }}
                                </span>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Agama
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.religion !== '' && detail.religion !== detail.customer_json.customer_religion ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.religion === '' ? detail.customer_json.customer_religion === '' ? '-' : detail.customer_json.customer_religion : detail.religion }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Alamat
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.address !== '' && detail.address !== detail.customer_json.customer_address ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.address === '' ? detail.customer_json.customer_address === '' ? '-' : detail.customer_json.customer_address : detail.address }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Provinsi
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.province_name !== '' && detail.province_name !== detail.customer_json.customer_province_name ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.province_name === '' ? detail.customer_json.customer_province_name === '' ? '-' : detail.customer_json.customer_province_name : detail.province_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Kabupaten
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.city_name !== '' && detail.city_name !== detail.customer_json.customer_city_name ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.city_name === '' ? detail.customer_json.customer_city_name === '' ? '-' : detail.customer_json.customer_city_name : detail.city_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Kecamatan
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.subdistrict_name !== '' && detail.subdistrict_name !== detail.customer_json.customer_subdistrict_name ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.subdistrict_name === '' ? detail.customer_json.customer_subdistrict_name === '' ? '-' : detail.customer_json.customer_subdistrict_name : detail.subdistrict_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Nama Kelurahan
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.village_name !== '' && detail.village_name !== detail.customer_json.customer_village_name ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.village_name === '' ? detail.customer_json.customer_village_name === '' ? '-' : detail.customer_json.customer_village_name : detail.village_name }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Latitude
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.latitude !== '' && detail.latitude !== detail.customer_json.customer_latitude ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.latitude === '' ? detail.customer_json.customer_latitude === '' ? '-' : detail.customer_json.customer_latitude : detail.latitude }}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td class="fs-14">
                              Longitude
                            </td>
                            <td style="width: 50px" class="text-center">
                              : 
                            </td>
                            <td class="text-left black--text py-1">
                              <div class="fs-14" :style="detail.longitude !== '' && detail.longitude !== detail.customer_json.customer_longitude ? 'color: green !important; font-weight: bold;' : ''">
                                {{ detail.longitude === '' ? detail.customer_json.customer_longitude === '' ? '-' : detail.customer_json.customer_longitude : detail.longitude }}
                              </div>
                            </td>
                          </tr>
                        </table>
                        

                        <!-- <div>
                          <div 
                            class="fs-12">
                           
                            Nama
                          </div>
                          <div class="fs-13 label-input" :style="detail.name !== '' && detail.name !== detail.customer_json.customer_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.name === '' ? detail.customer_json.customer_name : detail.name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Alias
                          </div>
                          <div class="fs-13 label-input" :style="detail.name_alias !== '' && detail.name_alias !== detail.customer_json.customer_name_alias ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.name_alias === '' ? detail.customer_json.customer_name_alias : detail.name_alias }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            NIK
                          </div>
                          <div class="fs-13 label-input" :style="detail.nik !== '' && detail.nik !== detail.customer_json.customer_nik ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.nik === '' ? detail.customer_json.customer_nik : detail.nik }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Email
                          </div>
                          <div class="fs-13 label-input" :style="detail.email !== '' && detail.email !== detail.customer_json.customer_email ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.email === '' ? detail.customer_json.customer_email : detail.email }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                           
                            Mobilephone
                          </div>
                          <div class="fs-13 label-input" v-if="detail.mobilephone_arr.length < 1">
                            <span v-if="detail.customer_json.customer_mobilephone_arr.length > 0">
                              <table>
                                <tr v-for="(item, i) in detail.customer_json.customer_mobilephone_arr" :key="i">
                                  <td>
                                    <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>
                                  </td>
                                  <td class="text-left py-1 pr-1 pl-5"  :style="detail.mobilephone_arr.length > 0 && detail.mobilephone_arr[i] !== detail.customer_json.customer_mobilephone_arr[i] ? 'color: green !important; font-weight: bold;' : ''">
                                    : {{ item }}
                                  </td>
                                </tr>
                              </table>
                            </span>
                            <span v-else>
                              -
                            </span>
                          </div>
                          <div class="fs-13 label-input" v-if="detail.mobilephone_arr.length > 0">
                            <span v-if="detail.mobilephone_arr.length > 0">
                              <table>
                                <tr v-for="(item, i) in detail.mobilephone_arr" :key="i">
                                  <td>
                                    <span v-if="i == 0">No. Phone 1</span><span v-if="i == 1">No. Phone 2</span><span v-if="i == 2">Whatsapp</span>
                                  </td>
                                  <td class="text-left py-1 pr-1 pl-5" :style="detail.mobilephone_arr.length > 0 && detail.mobilephone_arr[i] !== detail.customer_json.customer_mobilephone_arr[i] ? 'color: green !important; font-weight: bold;' : ''">
                                    : {{ item }}
                                  </td>
                                </tr>
                              </table>
                            </span>
                            <span v-else>
                              -
                            </span>
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            NPWP
                          </div>
                          <div class="fs-13 label-input" :style="detail.npwp !== '' && detail.npwp !== detail.customer_json.customer_npwp ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.npwp === '' ? detail.customer_json.customer_npwp : detail.npwp }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Faktur
                          </div>
                          <div class="fs-13 label-input" :style="detail.faktur !== '' ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.faktur === '' ? detail.customer_json.customer_faktur : detail.faktur }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Ketentuan
                          </div>
                          <div class="fs-13 label-input" :style="detail.term !== '' ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.term === '' ? detail.customer_json.customer_term : detail.term }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Tempat Lahir
                          </div>
                          <div class="fs-13 label-input" :style="detail.birthplace !== '' && detail.birthplace !== detail.customer_json.customer_birthplace ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.birthplace === '' ? detail.customer_json.customer_birthplace === '' ? '-' : detail.customer_json.customer_birthplace : detail.birthplace }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Tanggal Lahir
                          </div>
                          <div class="fs-13 label-input" :style="detail.birthdate !== '' && detail.birthdate !== detail.customer_json.customer_birthdate ? 'color: green !important; font-weight: bold;' : ''">
                            <span v-if="detail.birthdate === ''">
                              <span v-if="detail.customer_json.customer_birthdate === ''">
                                -
                              </span>
                              <span v-else>
                                {{ detail.customer_json.customer_birthdate | date }}
                              </span> 
                            </span>

                            <span>
                              {{ detail.birthdate | date }}
                            </span>
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Agama
                          </div>
                          <div class="fs-13 label-input" :style="detail.religion !== '' && detail.religion !== detail.customer_json.customer_religion ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.religion === '' ? detail.customer_json.customer_religion === '' ? '-' : detail.customer_json.customer_religion : detail.religion }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                            Alamat
                          </div>
                          <div class="fs-13 label-input" :style="detail.address !== '' && detail.address !== detail.customer_json.customer_address ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.address === '' ? detail.customer_json.customer_address === '' ? '-' : detail.customer_json.customer_address : detail.address }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Provinsi
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.province_name !== '' && detail.province_name !== detail.customer_json.customer_province_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.province_name === '' ? detail.customer_json.customer_province_name === '' ? '-' : detail.customer_json.customer_province_name : detail.province_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Kabupaten
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.city_name !== '' && detail.city_name !== detail.customer_json.customer_city_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.city_name === '' ? detail.customer_json.customer_city_name === '' ? '-' : detail.customer_json.customer_city_name : detail.city_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Kecamatan
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.subdistrict_name !== '' && detail.subdistrict_name !== detail.customer_json.customer_subdistrict_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.subdistrict_name === '' ? detail.customer_json.customer_subdistrict_name === '' ? '-' : detail.customer_json.customer_subdistrict_name : detail.subdistrict_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Kelurahan
                          </div>
                          <div class="fs-13 label-input text-lowercase" :style="detail.village_name !== '' && detail.village_name !== detail.customer_json.customer_village_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.village_name === '' ? detail.customer_json.customer_village_name === '' ? '-' : detail.customer_json.customer_village_name : detail.village_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Latitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.latitude !== '' && detail.latitude !== detail.customer_json.customer_latitude ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.latitude === '' ? detail.customer_json.customer_latitude === '' ? '-' : detail.customer_json.customer_latitude : detail.latitude }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Longitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.longitude !== '' && detail.longitude !== detail.customer_json.customer_longitude ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.longitude === '' ? detail.customer_json.customer_longitude === '' ? '-' : detail.customer_json.customer_longitude : detail.longitude }}
                          </div>
                        </div> -->

                        <div class="mb-3" :style="( detail.latitude !== '' && detail.latitude !== detail.customer_json.customer_latitude) || (detail.longitude !== '' && detail.longitude !== detail.customer_json.customer_longitude) ? 'color: green !important; font-weight: bold;' : ''">
                          Peta Lokasi
                        </div>
                        <div>
                          <div v-if="detail.latitude === '' && detail.longitude === ''">
                            <div v-if="detail.customer_json.customer_longitude === '' && detail.customer_json.customer_longitude === ''">
                              -
                            </div>
                            <div class="mt-6" v-else>
                                <a 
                                  :href="`https://www.google.com/maps/search/?api=1&query=${detail.customer_json.customer_latitude},${detail.customer_json.customer_longitude}`"
                                  style="color:#0000FF;text-align:left" 
                                    target="_blank">
                                      <iframe 
                                        width="100%" 
                                        height="170" 
                                        frameborder="0" 
                                        scrolling="no" 
                                        marginheight="0" 
                                        marginwidth="0" 
                                        :src="`https://maps.google.com/maps?q=${detail.customer_json.customer_latitude},${detail.customer_json.customer_longitude}&hl=es&z=14&amp;output=embed`"
                                        >
                                      </iframe>
                                    </a>
                              </div>
                            </div>
                          <div class="mt-6" v-else>
                              <a 
                                :href="`https://www.google.com/maps/search/?api=1&query=${detail.latitude === '' ? detail.customer_json.customer_latitude : detail.latitude},${detail.longitude === '' ? detail.customer_json.customer_longitude : detail.longitude}`"
                                style="color:#0000FF;text-align:left" 
                                  target="_blank">
                                    <iframe 
                                      width="100%" 
                                      height="170" 
                                      frameborder="0" 
                                      scrolling="no" 
                                      marginheight="0" 
                                      marginwidth="0" 
                                      :src="`https://maps.google.com/maps?q=${detail.latitude === '' ? detail.customer_json.customer_latitude : detail.latitude},${detail.longitude === '' ? detail.customer_json.customer_longitude : detail.longitude}&hl=es&z=14&amp;output=embed`"
                                      >
                                    </iframe>
                                  </a>
                            </div>
                        </div>


                        <div class="mb-3" :style="detail.ttd !== '' && detail.ttd !== detail.customer_json.customer_ttd ? 'color: green !important; font-weight: bold;' : ''">
                          Gambar Tanda Tangan
                        </div>

                        <v-img
                          :src="detail.ttd === '' ? detail.customer_json.customer_ttd : detail.ttd"
                          contain
                          width="250"
                          height="150"
                          >
                        </v-img>


                        <!-- <div>
                          <div 
                            class="fs-12">
                            Toko
                          </div>
                          <div class="fs-13 label-input" v-if="detail.store === null || detail.store.length < 1">
                            -
                          </div>
                          <div class="fs-13 label-input" v-else>
                            <v-list
                              subheader
                              three-line
                            >
                              <v-list-item
                                v-for="(item, index) in detail.store"
                                :key="index"
                                class="pl-0"
                              >
                                <v-list-item-avatar class="mr-3" tile>
                                  <v-icon
                                    color="#718EBF"
                                    size="45"
                                  >
                                    mdi-store
                                  </v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title>{{ item.store_name }}</v-list-item-title>

                                  <v-list-item-subtitle>{{ item.store_address }}</v-list-item-subtitle>
                                </v-list-item-content>

                              </v-list-item>
                            </v-list>
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12 mb-2">
                            Histori Approval
                          </div>
                          <div>
                            <div class="fs-15">
                              General Manager
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.gm_name === '' ? '-' : detail.edit_approval.General_Manager[0].user_name }} <span v-if="detail.edit_approval.General_Manager.length > 0">({{ detail.edit_approval.General_Manager[0].edit_approval_datetime | datetime }})</span>
                            </div>
                          </div>

                          <div>
                            <div class="fs-15">
                              Sales Manager
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.sm_name === '' ? '-' : detail.edit_approval.Sales_Manager[0].user_name }} <span v-if="detail.edit_approval.Sales_Manager.length > 0">({{ detail.edit_approval.Sales_Manager[0].edit_approval_datetime | datetime }})</span>
                            </div>
                          </div>

                          <div>
                            <div class="fs-15">
                              Supervisor
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.spv_name === '' ? '-' : detail.edit_approval.Supervisor[0].user_name }} <span v-if="detail.edit_approval.Supervisor.length > 0">({{ detail.edit_approval.Supervisor[0].edit_approval_datetime | datetime }})</span>
                            </div>
                          </div>
                        </div> -->


                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card
                flat
                class="mt-8"
                v-if="Object.keys(detail).length > 0 && detail.store_json !== ''"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div class="fs-17 input-label">
                    Toko
                  </div>
                  <v-row>
                    <v-col cols="6">
                      <div class="fs-15 mb-3 black--text" style="font-weight: 600">
                        Data Lama
                      </div>
                      <div>

                      <table style="width: auto;">
                        <tr>
                          <td class="fs-14">
                            Nama
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_name !== '' && detail.store_name !== detail.store_json.store_name ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Tipe Toko
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_type !== '' && detail.store_type !== detail.store_json.store_type ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_type }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Penanggung Jawab
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_pic_name !== '' && detail.store_pic_name !== detail.store_json.store_pic_name ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_pic_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nomor Penanggung jawab
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_pic_mobilephone !== '' && detail.store_pic_mobilephone !== detail.store_json.store_pic_mobilephone  ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_pic_mobilephone === null ? '-' : detail.store_json.store_pic_mobilephone }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Alamat
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_address !== '' && detail.store_address !== detail.store_json.store_address  ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_address }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Provinsi
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_province_name !== '' && detail.store_province_name !== detail.store_json.store_province_name ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_province_name === '' ? '-' : detail.store_json.store_province_name}}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Kabupaten
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_city_name !== '' && detail.store_city_name !== detail.store_json.store_city_name ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_city_name === '' ? '-' : detail.store_json.store_city_name}}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Kecamatan
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_subdistrict_name !== '' && detail.store_subdistrict_name !== detail.store_json.store_subdistrict_name ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_subdistrict_name === '' ? '-' : detail.store_json.store_subdistrict_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Kelurahan
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_village_name !== '' && detail.store_village_name !== detail.store_json.store_village_name ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_village_name === '' ? '-' : detail.store_json.store_village_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Latitude
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_latitude !== '' && detail.store_latitude !== detail.store_json.store_latitude ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_latitude }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Longitude
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_longitude !== '' && detail.store_longitude !== detail.store_json.store_longitude ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_longitude }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Catatan
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_notes !== '' && detail.store_notes !== detail.store_json.store_notes ? 'color: red !important; font-weight: bold;' : ''">
                              {{ detail.store_json.store_notes }}
                            </div>
                          </td>
                        </tr>
                      </table>
                        

                        <!-- <div>
                          <div 
                            class="fs-12">
                           
                            Nama
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_name !== '' && detail.store_name !== detail.store_json.store_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Penanggung Jawab
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_pic_name !== '' && detail.store_pic_name !== detail.store_json.store_pic_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_pic_name }}
                          </div>
                        </div>



                        <div>
                          <div 
                            class="fs-12">
                           
                            Nomor Penanggung jawab
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_pic_mobilephone !== '' && detail.store_pic_mobilephone !== detail.store_json.store_pic_mobilephone  ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_pic_mobilephone === null ? '-' : detail.store_json.store_pic_mobilephone }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Alamat
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_address !== '' && detail.store_address !== detail.store_json.store_address  ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_address }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Nama Provinsi
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_province_name !== '' && detail.store_province_name !== detail.store_json.store_province_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_province_name === '' ? '-' : detail.store_json.store_province_name}}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Nama Kabupaten
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_city_name !== '' && detail.store_city_name !== detail.store_json.store_city_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_city_name === '' ? '-' : detail.store_json.store_city_name}}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                            Nama Kecamatan
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_subdistrict_name !== '' && detail.store_subdistrict_name !== detail.store_json.store_subdistrict_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_subdistrict_name === '' ? '-' : detail.store_json.store_subdistrict_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                            Nama Kelurahan
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_village_name !== '' && detail.store_village_name !== detail.store_json.store_village_name ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_village_name === '' ? '-' : detail.store_json.store_village_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                           
                            Latitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_latitude !== '' && detail.store_latitude !== detail.store_json.store_latitude ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_latitude }}
                          </div>
                        </div>



                        <div>
                          <div 
                            class="fs-12">
                           
                            Longitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_longitude !== '' && detail.store_longitude !== detail.store_json.store_longitude ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_longitude }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Catatan
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_notes !== '' && detail.store_notes !== detail.store_json.store_notes ? 'color: red !important; font-weight: bold;' : ''">
                            {{ detail.store_json.store_notes }}
                          </div>
                        </div> -->

                        <div class="mb-3" >
                          <!-- :style="detail.store_images.length > 0 ? 'color: red !important; font-weight: bold;' : ''" -->
                          Gambar Tanda Tangan
                        </div>

                        <v-row>
                          <v-col cols="6"
                              v-for="(item, i) in detail.store_json.store_images"
                              :key="i">
                            <v-img
                              :src="item"
                              contain
                              width="150"
                              height="150"
                              class="mr-2"
                              >
                            </v-img>
                          </v-col>
                        </v-row>

                        <!-- <v-img
                          :src="detail.customer_json.customer_ttd"
                          contain
                          width="250"
                          height="150"
                          >
                        </v-img> -->
                        <a 
                          :href="`https://www.google.com/maps/search/?api=1&query=${detail.store_json.store_latitude},${detail.store_json.store_longitude}`"
                          style="color:#0000FF;text-align:left" 
                            target="_blank">
                              <iframe 
                                width="100%" 
                                height="170" 
                                frameborder="0" 
                                scrolling="no" 
                                marginheight="0" 
                                marginwidth="0" 
                                :src="`https://maps.google.com/maps?q=${detail.store_json.store_latitude},${detail.store_json.store_longitude}&hl=es&z=14&amp;output=embed`"
                                >
                              </iframe>
                            </a>
                      </div>
                    </v-col>
                    <v-col cols="6" style="border-left: 1px solid #E7E7E7;">
                      <div class="fs-15 mb-3 black--text" style="font-weight: 600">
                        Data Baru
                      </div>

                      <table style="width: auto;">
                        <tr>
                          <td class="fs-14">
                            Nama
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_name !== '' && detail.store_name !== detail.store_json.store_name ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_name === '' ? detail.store_json.store_name : detail.store_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Tipe Toko
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_type !== '' && detail.store_type !== detail.store_json.store_type ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_type === '' ? detail.store_json.store_type : detail.store_type }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Penanggung Jawab
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_pic_name !== '' && detail.store_pic_name !== detail.store_json.store_pic_name ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_pic_name === '' ? detail.store_json.store_pic_name : detail.store_pic_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nomor Penanggung jawab
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_pic_mobilephone !== '' && detail.store_pic_mobilephone !== detail.store_json.store_pic_mobilephone ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_pic_mobilephone === '' ? detail.store_json.store_pic_mobilephone === null ? '-' : detail.store_json.store_pic_mobilephone : detail.store_pic_mobilephone }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Alamat
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_address !== '' && detail.store_address !== detail.store_json.store_address ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_address === '' ? detail.store_json.store_address : detail.store_address }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Provinsi
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_province_name !== '' && detail.store_province_name !== detail.store_json.store_province_name ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_province_name === '' ? detail.store_json.store_province_name === '' ? '-' : detail.store_json.store_province_name : detail.store_province_name === '' ? '-' : detail.store_province_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Kabupaten
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_city_name !== '' && detail.store_city_name !== detail.store_json.store_city_name ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_city_name === '' ? detail.store_json.store_city_name === '' ? '-' : detail.store_json.store_city_name : detail.store_city_name === '' ? '-' : detail.store_city_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Kecamatan
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_subdistrict_name !== '' && detail.store_subdistrict_name !== detail.store_json.store_subdistrict_name ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_subdistrict_name === '' ? detail.store_json.store_subdistrict_name === '' ? '-' : detail.store_json.store_subdistrict_name : detail.store_subdistrict_name === '' ? '-' : detail.store_subdistrict_name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Nama Kelurahan
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_village_name !== '' && detail.store_village_name !== detail.store_json.store_village_name ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_village_name === '' ? detail.store_json.store_village_name === '' ? '-' : detail.store_json.store_village_name : detail.store_village_name === '' ? '-' : detail.store_village_name}}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Latitude
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_latitude !== '' && detail.store_latitude !== detail.store_json.store_latitude  ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_latitude === '' ? detail.store_json.store_latitude : detail.store_latitude }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Longitude
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_longitude !== '' && detail.store_longitude !== detail.store_json.store_longitude  ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_longitude === '' ? detail.store_json.store_longitude : detail.store_longitude }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="fs-14">
                            Catatan
                          </td>
                          <td style="width: 50px" class="text-center">
                            : 
                          </td>
                          <td class="text-left black--text py-1">
                            <div class="fs-14" :style="detail.store_notes !== '' && detail.store_notes !== detail.store_json.store_notes  ? 'color: green !important; font-weight: bold;' : ''">
                              {{ detail.store_notes === '' ? detail.store_json.store_notes : detail.store_notes }}
                            </div>
                          </td>
                        </tr>
                      </table>
                      <div>
                        

                        <!-- <div>
                          <div 
                            class="fs-12">
                           
                            Nama
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_name !== '' && detail.store_name !== detail.store_json.store_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_name === '' ? detail.store_json.store_name : detail.store_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Nama Penanggung Jawab
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_pic_name !== '' && detail.store_pic_name !== detail.store_json.store_pic_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_pic_name === '' ? detail.store_json.store_pic_name : detail.store_pic_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Nomor Penanggung jawab
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_pic_mobilephone !== '' && detail.store_pic_mobilephone !== detail.store_json.store_pic_mobilephone ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_pic_mobilephone === '' ? detail.store_json.store_pic_mobilephone === null ? '-' : detail.store_json.store_pic_mobilephone : detail.store_pic_mobilephone }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Alamat
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_address !== '' && detail.store_address !== detail.store_json.store_address ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_address === '' ? detail.store_json.store_address : detail.store_address }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Nama Provinsi
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_province_name !== '' && detail.store_province_name !== detail.store_json.store_province_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_province_name === '' ? detail.store_json.store_province_name === '' ? '-' : detail.store_json.store_province_name : detail.store_province_name === '' ? '-' : detail.store_province_name }}
                          </div>
                        </div>


                        <div>
                          <div 
                            class="fs-12">
                            Nama Kabupaten
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_city_name !== '' && detail.store_city_name !== detail.store_json.store_city_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_city_name === '' ? detail.store_json.store_city_name === '' ? '-' : detail.store_json.store_city_name : detail.store_city_name === '' ? '-' : detail.store_city_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Nama Kecamatan
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_subdistrict_name !== '' && detail.store_subdistrict_name !== detail.store_json.store_subdistrict_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_subdistrict_name === '' ? detail.store_json.store_subdistrict_name === '' ? '-' : detail.store_json.store_subdistrict_name : detail.store_subdistrict_name === '' ? '-' : detail.store_subdistrict_name }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                            Nama Kelurahan
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_village_name !== '' && detail.store_village_name !== detail.store_json.store_village_name ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_village_name === '' ? detail.store_json.store_village_name === '' ? '-' : detail.store_json.store_village_name : detail.store_village_name === '' ? '-' : detail.store_village_name}}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Latitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_latitude !== '' && detail.store_latitude !== detail.store_json.store_latitude  ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_latitude === '' ? detail.store_json.store_latitude : detail.store_latitude }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Longitude
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_longitude !== '' && detail.store_longitude !== detail.store_json.store_longitude  ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_longitude === '' ? detail.store_json.store_longitude : detail.store_longitude }}
                          </div>
                        </div>

                        <div>
                          <div 
                            class="fs-12">
                           
                            Catatan
                          </div>
                          <div class="fs-13 label-input" :style="detail.store_notes !== '' && detail.store_notes !== detail.store_json.store_notes  ? 'color: green !important; font-weight: bold;' : ''">
                            {{ detail.store_notes === '' ? detail.store_json.store_notes : detail.store_notes }}
                          </div>
                        </div> -->

                        <div class="mb-3">
                          <!-- :style="detail.store_images.length > 0 ? 'color: green !important; font-weight: bold;' : ''" -->
                          Gambar Tanda Tangan
                        </div>

                        <v-row>
                          <v-col cols="6"
                              v-for="(item, i) in detail.store_images.length > 0 ? detail.store_images : detail.store_json.store_images"
                              :key="i">
                            <v-img
                              :src="item"
                              contain
                              width="150"
                              height="150"
                              class="mr-2"
                              >
                            </v-img>
                          </v-col>
                        </v-row>

                        <a 
                        :href="`https://www.google.com/maps/search/?api=1&query=${detail.store_latitude},${detail.store_longitude}`"
                        style="color:#0000FF;text-align:left" 
                          target="_blank">
                            <iframe 
                              width="100%" 
                              height="170" 
                              frameborder="0" 
                              scrolling="no" 
                              marginheight="0" 
                              marginwidth="0" 
                              :src="`https://maps.google.com/maps?q=${detail.store_latitude},${detail.store_longitude}&hl=es&z=14&amp;output=embed`"
                              >
                            </iframe>
                          </a>
                      </div>

                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card
                flat
                class="mt-8"
                v-if="Object.keys(detail).length > 0"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div class="fs-18 input-label mb-4">
                    Approval
                  </div>
                  <div>
                    <div>
                      Status Approval
                    </div>
                    <div class="fs-13 label-input">
                      {{ detail.status === 'proses' ? 'Proses' : detail.status === 'approved' ? 'Diterima' : 'Ditolak'}}
                    </div>
                  </div>
                  <div class="" v-if="detail.status === 'rejected'">
                    <div>
                      Alasan
                    </div>
                    <div class="fs-13 label-input">
                      {{ detail.rejected_reason }}
                    </div>
                  </div>
                  <v-row v-if="detail.status !== 'rejected'">

                    <v-col cols="12" md="4">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Supervisor
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <div v-if="detail.gm_name === '' && user.category_user_title === 'General Manager' && detail.spv_name === ''">
                            <v-checkbox
                              v-model="approved_by"
                              value="Supervisor"
                              color="white"
                              v-on:change="toChange()"
                              style="color: white !important"
                              hide-details
                            ></v-checkbox>
                          </div>

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          Supervisor
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.spv_name === '' ? '-' : detail.spv_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b v-if="detail.spv_datetime.length > 0">{{  detail.spv_datetime | datetime  }}</b>
                              <b v-else>
                                -
                              </b>
                            </span>
                          </p>

                          <div v-if="detail.approved_reason.name === 'Supervisor' || detail.approved_reason.name === 'all'"  class="mt-2">

                            <div>
                              Alasan Approve
        
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.approved_reason.reason }}
                            </div>
                          </div>


                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Sales Manager
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <div v-if="detail.gm_name === '' && user.category_user_title === 'General Manager' && detail.sm_name === ''">
                            <v-checkbox
                              v-model="approved_by"
                              :disabled="detail.spv_name === '' ? approved_by.length > 0 ? false : true : false"
                              color="white"
                              value="Sales Manager"
                              hide-details
                            ></v-checkbox>
                          </div>

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          Sales Manager
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.sm_name === '' ? '-' : detail.sm_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <span>
                                <b v-if="detail.sm_datetime.length > 0">{{  detail.sm_datetime | datetime  }}</b>
                                <b v-else>
                                  -
                                </b>
                              </span>
                            </span>
                          </p>

                          <div v-if="detail.approved_reason.name === 'Sales Manager' || detail.approved_reason.name === 'all'" class="mt-2">

                            <div>
                              Alasan Approve
        
                            </div>
                            <div class="fs-13 label-input">
                              {{ detail.approved_reason.reason }}
                            </div>
                          </div>



                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            General Manager
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          General Manager
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.gm_name === '' ? '-' : detail.gm_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b v-if="detail.gm_datetime.length > 0">{{  detail.gm_datetime | datetime  }}</b>
                              <b v-else>
                                -
                              </b>
                            </span>
                          </p>


                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row v-if="detail.status === 'rejected'">
                    <v-col cols="12" md="4">
                      <v-card
                        class="pa-0"
                        height="100%"
                        flat
                        style="border-radius: 15px; border: 1px solid #E7E7E7;">
                        <v-toolbar
                          :color="set_color"
                          dark>
                          <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                            Staff yg Menolak
                          </v-toolbar-title>

                          <v-spacer></v-spacer>
                          <!-- <div v-if="detail.customer_approval.General_Manager.length < 1 && user.category_user_title === 'General Manager' && detail.customer_approval.Supervisor.length < 1">
                            <v-checkbox
                              v-model="approve_name"
                              v-on-change="$emit('approved', approve_name)"
                              value="Supervisor"
                              color="white"
                              style="color: white !important"
                              hide-details
                            ></v-checkbox>
                          </div> -->

                        </v-toolbar>

                        <!-- <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                          Supervisor
                        </v-card-text> -->

                        <v-card-text class="body-2 font-weight-light text-first">
                          <!-- <p class="mb-2">
                            <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                            <span v-if="item.start === item.end">
                              Tanggal <b>{{ item.date | date }}</b>
                            </span>
                          </p> -->

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-account</v-icon>
                            <span>
                              <b>{{ detail.user_rejected_name }}</b>
                            </span>
                          </p>

                          <p class="mb-2">
                            <v-icon small class="mr-2">mdi-calendar-month</v-icon>
                            <span>
                              <b>{{ detail.rejected_date | date  }}</b>
                            </span>
                          </p>


                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <!-- <div
                v-if="!process.load && detail.status === 'proses'">

                <div
                  v-if="user.category_user_title === 'Supervisor' && detail.spv_name === ''  && detail.approved_by !== 'Supervisor,Sales Manager,General Manager' && detail.approved_by !== 'Supervisor,General Manager'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-13 white--text text-capitalize border-radius">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="reset(); dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-13 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>
                </div>

                <div
                  v-else-if="user.category_user_title === 'Sales Manager' && detail.sm_name === '' && detail.approved_by !== 'Supervisor,Sales Manager,General Manager' && detail.approved_by !== 'Sales Manager,General Manager'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-13 white--text text-capitalize border-radius">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="reset(); dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-13 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>
                </div>
                
                <div
                  v-else-if="user.category_user_title === 'General Manager' && detail.gm_name === ''"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-13 white--text text-capitalize border-radius">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="reset(); dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-13 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>  
                </div>
              </div> -->

              <div
                v-if="!process.load && detail.status === 'proses'">

                <div
                  v-if="user.category_user_title === 'Supervisor' && detail.spv_id === '0'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                    :loading="process.load"
                    :disabled="process.load"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize border-radius">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="message.error = ''; rejected_reason = ''; dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>
                </div>

                <div
                  v-else-if="user.category_user_title === 'Sales Manager' && detail.sm_id === '0'"
                  class="d-flex align-center">
                  <v-btn 
                    @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                    :loading="process.load"
                    :disabled="process.load"
                    v-if="detail.spv_id !== '0'"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize border-radius">
                    Diterima
                  </v-btn>
    
                  <v-btn
                    @click="message.error = ''; rejected_reason = ''; dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    width="120"
                    height="45"
                    elevation="0"
                    color="warning"
                    class="fs-16 ml-4 white--text text-capitalize border-radius">
                    Ditolak
                  </v-btn>
                </div>
                
                <div
                  v-else-if="user.category_user_title === 'General Manager' && detail.gm_id === '0'"
                  class="d-flex align-center">
                  <div v-if="detail.sm_id === '0' && detail.spv_id === '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      v-if="approved_by.filter(item => item === 'Sales Manager').length > 0"
                      color="#1814F3"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
                  <div v-if="detail.sm_id !== '0' && detail.spv_id === '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      v-if="approved_by.filter(item => item === 'Supervisor').length > 0"
                      color="#1814F3"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
                  <div v-if="detail.sm_id === '0' && detail.spv_id !== '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      v-if="approved_by.filter(item => item === 'Sales Manager').length > 0"
                      color="#1814F3"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
                  <div v-if="detail.sm_id !== '0' && detail.spv_id !== '0'">
                    <v-btn 
                      @click="dialog.status = true; message.error = ''; message.status = 'terima'; approved_reason = ''"
                      :loading="process.load"
                      :disabled="process.load"
                      elevation="0"
                      color="#1814F3"
                      :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                      :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                      :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                      class="fs-16 white--text text-capitalize">
                      Diterima
                    </v-btn>
                  </div>
    
                  <v-btn
                    @click="message.error = ''; rejected_reason = ''; dialog.status = true; message.error = ''; message.status = 'tolak'"
                    :loading="process.load"
                    :disabled="process.load"
                    elevation="0"
                    color="warning"
                    :width="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 150"
                    :height="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 45"
                    :class="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? '' : 'border-radius'"
                    class="fs-16 white--text ml-3 text-capitalize">
                    Ditolak
                  </v-btn>  
                </div>
              </div>

              
              <v-btn
                to="/customer/perubahan"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false
        },

        detail: {},

        rejected_reason: '',

        form: {
          id: '',
          sales_id: '',
          name_alias: '',
          name: '',
          mobilephone_arr: [],
          email: '',
          nik: '',
          npwp: '',
          plafon: '',
          faktur: '',
          term: '',
          ttd: ''
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      toChange () {
        if(this.approved_by.length > 0 && this.approved_by[0] === 'Sales Manager') {
          this.approved_by = [] 
        }
        // this.$emit('approved', this.approve_name)
      },
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/customer_edit/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
            this.detail.mobilephone_arr = this.detail.mobilephone_arr.length > 0 ? JSON.parse(this.detail.mobilephone_arr) : []
            this.detail.customer_json = this.detail.customer_json.length > 0 ? JSON.parse(this.detail.customer_json) : {}
            this.detail.customer_json.customer_address = this.detail.customer_json.customer_address === undefined ? '' : this.detail.customer_json.customer_address
            this.detail.customer_json.customer_mobilephone_arr = this.detail.customer_json.customer_mobilephone_arr.length > 0 ? JSON.parse(this.detail.customer_json.customer_mobilephone_arr) : []
            this.detail.store_json = this.detail.store_json === 'null' ? '' : this.detail.store_json.length > 0 ? JSON.parse(this.detail.store_json) : ''
            this.detail.store_images = this.detail.store_images.length > 0 ? JSON.parse(this.detail.store_images) : []
            if (this.detail.store_json !== '') {
              this.detail.store_json.store_images = this.detail.store_json.store_images.length > 0 ? JSON.parse(this.detail.store_json.store_images) : []
            }
            if (this.detail.store_json !== '') {
              this.detail.store_json.store_province_name = this.detail.store_json.store_province_name === undefined ? '' : this.detail.store_json.store_province_name
              this.detail.store_json.store_city_name = this.detail.store_json.store_city_name === undefined ? '' : this.detail.store_json.store_city_name
              this.detail.store_json.store_subdistrict_name = this.detail.store_json.store_subdistrict_name === undefined ? '' : this.detail.store_json.store_subdistrict_name
              this.detail.store_json.store_village_name = this.detail.store_json.store_village_name === undefined ? '' : this.detail.store_json.store_village_name
            }
            this.detail.customer_json.customer_latitude = this.detail.customer_json.customer_latitude === undefined ? '' : this.detail.customer_json.customer_latitude === null ? '' : this.detail.customer_json.customer_latitude
            this.detail.customer_json.customer_longitude = this.detail.customer_json.customer_longitude === undefined ? '' : this.detail.customer_json.customer_longitude === null ? '' : this.detail.customer_json.customer_longitude
            this.detail.customer_json.customer_birthplace = this.detail.customer_json.customer_birthplace === undefined ? '' : this.detail.customer_json.customer_birthplace
            this.detail.customer_json.customer_birthdate = this.detail.customer_json.customer_birthdate === undefined ? '' : this.detail.customer_json.customer_birthdate
            this.detail.customer_json.customer_religion = this.detail.customer_json.customer_religion === undefined ? '' : this.detail.customer_json.customer_religion
            this.detail.customer_json.customer_province_name = this.detail.customer_json.customer_province_name === undefined ? '' : this.detail.customer_json.customer_province_name
            this.detail.customer_json.customer_city_name = this.detail.customer_json.customer_city_name === undefined ? '' : this.detail.customer_json.customer_city_name
            this.detail.customer_json.customer_subdistrict_name = this.detail.customer_json.customer_subdistrict_name === undefined ? '' : this.detail.customer_json.customer_subdistrict_name
            this.detail.customer_json.customer_village_name = this.detail.customer_json.customer_village_name === undefined ? '' : this.detail.customer_json.customer_village_name
            this.detail.approved_reason = this.detail.approved_reason.length < 1 ? { name: '', reason: '' } : JSON.parse(this.detail.approved_reason)
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''
        const isValid = this.message.status === 'terima' ? this.approved_by.length > 0 ? await this.$refs.form.validate() : true : await this.$refs.form.validate()
        if (isValid) {
          

        this.process.form = true
        let approved_reason = {
          name: '',
          reason: ''
        }
        if (this.message.status === 'terima') {
          if(this.approved_by.length === 1 && this.approved_by[0] === 'Supervisor') {

            approved_reason = {
              name: 'Supervisor',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length === 1 && this.approved_by[0] === 'Sales Manager') {
            approved_reason = {
              name: 'Sales Manager',
              reason: this.approved_reason
            }
          } else if(this.approved_by.length > 1) {
            approved_reason = {
              name: 'all',
              reason: this.approved_reason
            }
          } 
        }
        // console.log(this.approved_by.filter(item => item === 'Sales Manager').length > 0)

        await post(`admin/customer_edit/approval`, {
          data: {
            edit_id: this.detail.id,
            status: this.message.status === 'terima' ? 'approved' : 'rejected',
            // approved_by: this.message.status === 'terima' ? this.approved_by.length < 1 ? this.user.category_user_title === 'General Manager' ? this.detail.approved_by === 'Supervisor,Sales Manager' ? `Supervisor,Sales Manager,General Manager` : this.detail.approved_by === 'Supervisor' ? `Supervisor,General Manager` : this.detail.approved_by === 'Sales Manager' ? `Sales Manager,General Manager` : this.user.category_user_title : this.user.category_user_title :  this.approved_by.length === 1 ? this.detail.approved_by === '' ? `${this.approved_by[0]},General Manager` :  `Supervisor,Sales Manager,General Manager` : `Supervisor,Sales Manager,General Manager` : '',
            approved_reason: this.detail.approved_reason.name === '' ? JSON.stringify(approved_reason) : JSON.stringify(this.detail.approved_reason),
            rejected_reason: this.rejected_reason,
            spv_id: this.detail.spv_id !== '0' ? this.detail.spv_id : this.user.category_user_title === 'General Manager' ? this.approved_by.filter(item => item === 'Supervisor').length > 0 ? this.user.id : this.detail.spv_id : this.user.category_user_title === 'Supervisor' ? this.user.id : this.detail.spv_id, 
            sm_id: this.detail.sm_id !== '0' ? this.detail.sm_id : this.user.category_user_title === 'General Manager' ? this.approved_by.filter(item => item === 'Sales Manager').length > 0 ? this.user.id : this.detail.sm_id : this.user.category_user_title === 'Sales Manager' ? this.user.id : this.detail.sm_id,
            gm_id: this.detail.gm_id !== '0' ? this.detail.gm_id : this.user.category_user_title === 'General Manager' ? this.user.id : this.detail.gm_id
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      }
    }
  }
</script>